export const API = {
  Login: "/TokenAuth/Authenticate",
  ManageSchedule: "/UserSchedule",
  setNewPassword: "/services/app/User/SetNewPassword",
  forgetPassword: "/services/app/User/ForgetPassword",
  fcnAdminList: "/services/app/Tenant/GetAdminList",

  //Signup
  companyExist: "/services/app/Account/IsCompanyNameExists",
  EmailExist: "/services/app/Account/IsEmailExists",
  signUp: "/services/app/Account/Register",
  //Dashboard
  DashboardGetAllocators: "/services/app/Dashboard/GetAllocators",
  DashboardGetMyFunds: "/services/app/Dashboard/GetFunds",
  getDashboardConfig: "/DashboardConfiguration/Get",
  updateDashboardConfig: "/DashboardConfiguration/Create/Update",
  cooperativeEmail: "/services/app/Account/IsTenantCooperativeEmail",

  //Stage Allocation
  StageAllocatorList : "/StageAllocation/StageAllocators",

  //Chat
  GetRooms: "/chat/rooms",
  UploadFile: "/chat/UploadFile",
  GetRecentChat: "/Chat/recent",
  searchAllocators: "/Allocator",
  myFunds: "/Fund/search",
  GetRoomMessages: "/Chat/GetRoomMessages",
  GetArchive: "/Room/GetArchive",
  UpdateArchive: "/Room/Archive",

  // My Meetings
  GetMeetings: "/Appointment",
  CreateAppointment : "/Appointment",
  FundDetail: "/Fund/Detail",
  FundProfileDetail : "/Fund/FundProfileDetail",

  AllocatorDetail: "/Allocator/Detail",

  HedgeFundProfile: "/Profile",

  //Dashboard Meetings
  Meetings: "/services/app/Dashboard/GetMeetings",
  // Allocator Info
  GetAllocatorInfo : "/AllocatorInfo/AllocatorInfo",
  //Cuurent User
  CurrentUser: "/services/app/User/GetCurrentUserDetails",

  //Update User
  UpdateUser: "/services/app/User/UpdateProfileInfo",

  // Create New User
  CreateUser: "/services/app/User/Create",

  //Two Factor Auth
  TwoFactor: "/TokenAuth/VerifyTwoFactorCode",
  SendTwoFactorCodeUrl: "/services/app/User/SendTwoFactorCode",
  SendVerifyPhoneNumberUrl: "/services/app/User/SendPhoneVerificationCode",
  fundBioUsers : "/services/app/User/GetUsersWithFundBios",
  SendTwoFactorCodeToEmailUrl : "/services/app/User/SendTwoFactorCodeToEmail",

  //Verify Phone
  VerifyPhone: "/TokenAuth/VerifyCode",
  // MessageSeen
  GetUnSeenMessages: "/MessageSeen/UnSeenMessages",
  //Upload Tear Sheet
  TearSheetUpload: "/Fund/Performance/Metrics",

  //Get Posts
  GetPost: "/PostFeed/Get",

  //Create New Post
  CreatePost: "/PostFeed/Create",

  //Get investor type
  InvestorType: "/services/app/InvestorType/GetAll",
  // update Tenant info
  UpdateTenant: "/services/app/Tenant/UpdateCurrentTenantInfo",
  UpdateTenantCoverImage: "/services/app/Tenant/UpdateCoverImage",
  UpdateTenantCompantLogo: "/services/app/Tenant/UpdateLogoImage",
  GetCompanyUsers : "/services/app/Tenant/GetCompanyTenantUsers",
  GetHedgeFundUsers : "/services/app/Tenant/GetHedgeFundUsers",
  GetinvestedAllocator : "/services/app/Tenant/GetInvestedAllocators",

  GetAllocatorUsers : "/services/app/Tenant/GetCompanyTenantUsers",
  CreateChatRoom : "/Chat",

  //My Posts
  MyPost: "/PostFeed/CurrentUserPostFeed",
  // SEEN MESSAGES
  SeenMessages: "/MessageSeen",
  //Delete Post
  DeletePost: "/PostFeed/Delete",

  //Get Current Post Details
  GetPostDetails: "/PostFeed/GetPostDetail",

  //Update Post
  UpdatePost: "/PostFeed/Update",
  //Follow Allocator
  FollowAllocator: "/Allocator/Follow",

  //Get Meeting Details
  GetMeetingDetails: "/Appointment/GetMeetingDetails",

  // Update Meeting Attendee Status
  UpdateAttendeeStatus: "/Appointment/UpdateAttendeeStatus",
  //Get Region
  GetRegion: "/Region",

  //Get Strategies
  GetStrategies: "/Strategy",
  getStrategy: "/Strategy/GetStrategy",
  // Record Files
  getRecordFiles : "/RecordFile/Records",
  //Create Fund
  CreateFund: "/Fund",

  //FCN Query
  // FCNQuery: "/Create",
  // HedgeFund Connection
  HedgefundConnection : "/Fund/HedgeFundConnection",

  //Investor List
  GetInvestorList: "/Fund/GetInvestorsList",
  //Contact FCN Admin
  FCNQuery: "/FcnQuery/Create",

  //Fund Publish
  FundPublish: "/Fund/Publish",

  //Get All Documents
  GetDocument: "/Document/Detail",

  //Upload Document
  UploadDocument: "/Document/Upload",

  //Update Document Status
  UpdateDocumentStatus: "/Document/Status",
  //Alert
  GetAlerts: "/services/app/Alert/GetAlerts",
  UpdateToSeen: "/services/app/Alert/UpdateToSeen",

  //GetRecentPost
  GetRecentPost: "/services/app/Dashboard/GetRecentPostFeeds",
  // Stage Allocation
  GetStageAllocationCount : "/services/app/Dashboard/GetStageAllocationCount",
  //update monthly return
  UpdateMonthlyReturn: "/Fund/UpdateMonthlyReturn",

  //Roles and Permissions
  RolesAndPermissions: "/services/app/Session/GetCurrentLoginInformations",

  //Get All Users
  GetAllUser: "/services/app/User/GetAllUsers",

  //Get User Details
  GetUser: "/services/app/User/GetUserDetail",

  //Update User Details
  UpdateUserDetail: "/services/app/User/UpdateCompanyUserProfileInfo",

  //Update User Status
  UpdateUserStatus: "/services/app/User/UpdateStatus",

  //Get User Roles
  GetRoles: "/services/app/User/GetRoles",

  //Update user Password
  UpdatePassword: "/services/app/User/ResetPassword",

  // change password
  ChangePassword: "services/app/User/ChangePassword",

  // upload file deck
  UploadFileDeck: "Fund/Deck/Upload",

  //Get Performance Metrics Search Result
  GetPerformanceMetricsSearchResult: "/Fund/GetPerformanceSearchResult",
  //Get Risk Report Search Result
  GetRiskReportSearchResult: "/Fund/GetRiskReportSearchResult",
  RiskReportSearchResultByMonth: "/Fund/RiskReportSearchResultByMonth",

  //impersonation
  AdminLogin: "/TokenAuth/AuthenticateImpersonateUser",

  // AuditLogs 
  CreateAuditLogs: "/AuditLog/AuditLog",
  // Preferences
  GetEmailTemplates: "/Preference/GetEmailTemplates",
  CreateUserPreference: "/Preference/InsertOrUpdatePreference",

  //Get all Meetings
  GetMonthlyMeetings: "/Appointment/GetMonthlyMeetingDetails",

  //Import allocator contacts
  ImportAllocatorContact: "/AllocatorContact/ImportContacts",

  //Get Fund Types
  GetFundTypes: "/services/app/FundType/GetAll"
};

export const setStorageItem = (storage, key, value, callback) => {
  var result = storage.setItem(key, value);
  if (result instanceof window.Promise && callback) {
    result.then(callback);
  } else if (callback) {
    callback();
  }
};
export const getStorageItem = (storage, key, callback) => {
  var result = storage.getItem(key);
  if (result instanceof window.Promise && callback) {
    result.then(callback);
  } else if (callback) {
    callback();
  }
};
export const setSessionStorageItem = (sessionStorage, key, value, callback) => {
  var result = sessionStorage.setItem(key, value);
  if (result instanceof window.Promise && callback) {
    result.then(callback);
  } else if (callback) {
    callback();
  }
};

export const getSessionStorageItem = (sessionStorage, key, callback) => {
  var result = sessionStorage.getItem(key);
  if (result instanceof window.Promise && callback) {
    result.then(callback);
  } else if (callback) {
    callback();
  }
};

